import { render, staticRenderFns } from "./NotifySetting.vue?vue&type=template&id=2b542f0a&scoped=true"
import script from "./NotifySetting.vue?vue&type=script&lang=js"
export * from "./NotifySetting.vue?vue&type=script&lang=js"
import style0 from "./NotifySetting.vue?vue&type=style&index=0&id=2b542f0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b542f0a",
  null
  
)

export default component.exports